import { AxiosResponse } from 'axios'
import { Moment } from 'moment'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { IPaginatedResponse } from 'services/core/paginatedResponseCore'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const DocumentoCaixaServices = () => {
  const path: String = 'DocumentoCaixa'

  const create = async (
    dto: INewDocumentoCaixaRequestDto
  ): Promise<AxiosResponse<any>> =>
    await RequestCDU.post(`${path}/CreateDocumentoCaixa`, dto)

  const update = async (
    dto: IDocumentoCaixaRequestDto
  ): Promise<AxiosResponse<any>> =>
    await RequestCDU.patch(`${path}/Update`, dto)

  const del = async (idDocumento: number): Promise<AxiosResponse<any>> =>
    await RequestCDU.delete(`${path}/Delete`, { params: { id: idDocumento } })

  const getAll = async (): Promise<
    AxiosResponse<IDocumentoCaixaResponseDto[]>
  > => await RequestREAD.get(`${path}`)

  const getAllPaginated = async (
    pageNumber: number,
    pageSize: number
  ): Promise<AxiosResponse<IPaginatedResponse<IDocumentoCaixaResponseDto>>> =>
    await RequestREAD.get(`${path}/GetPaginated`, {
      params: { pageNumber, pageSize }
    })

  const getById = async (
    idDocumento: number
  ): Promise<AxiosResponse<IDocumentoCaixaResponseDto>> =>
    await RequestREAD.get(`${path}/${idDocumento}`)

  const search = async (
    params: IDocumentoCaixaSearchDto,
    pageNumber: number,
    pageSize: number
  ): Promise<AxiosResponse<IPaginatedResponse<IDocumentoCaixaResponseDto>>> =>
    await RequestREAD.get(`${path}/Search`, {
      params: { ...params, pageNumber, pageSize }
    })

  return { create, del, getAll, getAllPaginated, getById, search, update }
}

export const CaixaServices = () => {
  const path: String = 'Caixa'

  const create = async (
    dto: ICaixaRequestDto
  ): Promise<AxiosResponse<IGenericEntityResponse<ICaixaResponseDto>>> =>
    await RequestCDU.post(`${path}/Create`, dto)

  const update = async (
    dto: IDocumentoCaixaRequestDto
  ): Promise<AxiosResponse<ICaixaResponseDto>> =>
    await RequestCDU.patch(`${path}/Update`, dto)

  const del = async (idCaixa: number): Promise<AxiosResponse<any>> =>
    await RequestCDU.delete(`${path}/Delete/${idCaixa}`)

  const getAll = async (): Promise<AxiosResponse<ICaixaResponseDto>> =>
    await RequestREAD.get(`${path}`)

  const getById = async (
    idCaixa: number
  ): Promise<AxiosResponse<ICaixaResponseDto>> =>
    await RequestREAD.get(`${path}/${idCaixa}`)

  const findAtual = async (
    idCentroPlanta?: number
  ): Promise<AxiosResponse<ICaixaResponseDto>> =>
    await RequestREAD.get(`${path}/BuscarAtual`, {
      params: {
        idCentroPlanta
      }
    })

  return { create, del, findAtual, getAll, getById, update }
}

export const CompanyServices = () => {
  const path: String = 'Empresa'

  const getAll = async (): Promise<AxiosResponse<IEmpresaDto[]>> =>
    await RequestREAD.get(`${path}`)

  return {
    getAll
  }
}

export const CenterServices = () => {
  const path: String = 'CentroPlanta'

  const getAll = async (): Promise<
    AxiosResponse<IGenericEntityResponse<ICentroPlantaDto[]>>
  > => await RequestREAD.get(`${path}`)

  return {
    getAll
  }
}

export interface ICentroPlantaDto {
  idCentroPlanta: number
  txDescricao: string
  empresaId: number
  tEmpresa: any[]
}

export interface IEmpresaDto {
  idEmpresa: number
  cdSap: string
  txDescricao: string
  flAtiva: boolean
  tContratos: any[]
}

// Documento Caixa
export interface IDocumentoCaixaRequestDto {
  idDocumentoCaixa: number
  idContrato: number
  idCaixa: number
  nuAnoMesCompetencia: string
  txDescricaoCaixa: string
}
export interface INewDocumentoCaixaRequestDto
  extends IDocumentoCaixaRequestDto {
  isCaixaExterna: boolean
  nuCaixa: number
  idCentroPlanta: number
}

export interface IDocumentoCaixaResponseDto {
  idDocumentoCaixa: number
  idContrato: number
  idCaixa: number
  flCaixaAtual: boolean
  codigoContrato: string
  idCentroPlanta?: number
  nmEmpresa: string
  nmCentroPlanta: string
  cnpj: string
  fornecedor: string
  competencia: string
  descricao: string
  nuCaixa: number
  isCaixaExterno: boolean
}

export interface IDocumentoCaixaSearchDto {
  numContrato: string
  codEmpresa: number
  codCentro: number
  cnpj: string
  fornecedor: string
  competencia: string
  nuCaixaExterno: number
  nuCaixaDepartamental: number
}

// Caixa
export interface ICaixaResponseDto {
  idCaixa: number
  nuCaixa: number
  flCaixaAtual: boolean
  nuAnoMesCompetencia: string
  idTipoCaixa: number
  idCentroPlanta?: number
}

export interface ICaixaRequestDto {
  idCaixa?: number
  nuCaixa: number
  idTipoCaixa: number
  idCentroPlanta: number
  flCaixaAtual: boolean
  isAbrirCaixa: boolean
}

export enum TipoCaixa {
  // eslint-disable-next-line no-unused-vars
  Externa = 1,
  // eslint-disable-next-line no-unused-vars
  Departamental = 2
}

export type CompetenciaCaixa = string | Date | null | Moment

export interface ICaixaModel {
  idCaixa: number
  numeroCaixa: string
  idTipoCaixa: TipoCaixa
}

export interface ICaixaForm {
  idDocumentoCaixa?: number
  cdContrato: string
  nmEmpresa: string
  nmCentro: string
  cnpj: string
  competencia: CompetenciaCaixa
  descricao: string
  nmFornecedor: string
  currentCaixa: TipoCaixa
  caixaExterna: ICaixaModel
  caixaDepartamental: ICaixaModel
}
